var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

import React, { Component } from 'react';
import './AirButton.css';

var AirButton = function (_Component) {
  _inherits(AirButton, _Component);

  function AirButton() {
    _classCallCheck(this, AirButton);

    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  AirButton.prototype.render = function render() {
    return React.createElement('div', {
      className: 'AirButton ' + (this.props.className || '') + ' ' + (this.props.size || 'small') + ' ' + (!!this.props.icon ? 'withIcon' : '') + ' ' + (this.props.hasOwnProperty('light') ? 'light' : 'dark') + ' ' + (this.props.label ? 'withLabel' : ''),
      onClick: !this.props.disabled ? this.props.onClick : undefined,
      style: _extends({
        color: this.props.color
      }, this.props.style)
    }, React.createElement('div', null, React.createElement('div', {
      className: 'buttonInner'
    }, React.createElement('div', {
      className: 'bg',
      style: {
        backgroundColor: this.props.bgColor
      }
    }), React.createElement('div', null, this.props.icon, this.props.size === 'large' && React.createElement('div', {
      className: 'label'
    }, this.props.label))), this.props.size !== 'large' && React.createElement('div', {
      className: 'label',
      style: {
        margin: 0
      }
    }, this.props.label)));
  };

  return AirButton;
}(Component);

export { AirButton as default };